<h3>{{'help.formStep.step3'|translate}}</h3>
<mat-accordion [multi]="true" displayMode="flat" class="accordion-container">
  <ng-container *ngFor="let faq of (faqs$ | async)">
  <mat-expansion-panel [togglePosition]="'after'">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div>
          <div class="video-title">{{ faq?.attributes.title }}</div>
          <div class="link"></div>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <hr />
      <div class="content">
        <markdown [data]="faq?.attributes.content"></markdown>
      </div>
    </ng-template>
  </mat-expansion-panel>
  </ng-container>
</mat-accordion>

